/* tslint:disable */
/* eslint-disable */
/**
 * Elion Dashboard Backend API
 *  ## Welcome to the Elion Dashboard Backend API! The **Elion-Dashboard-Backend** is the module that handles all calls required to provide the data for the Elion Dashboard.  
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface LocationInner
 */
export interface LocationInner {
}
/**
 * 
 * @export
 * @interface SiteAddressResponse
 */
export interface SiteAddressResponse {
    /**
     * 
     * @type {string}
     * @memberof SiteAddressResponse
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteAddressResponse
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteAddressResponse
     */
    'city'?: string;
}
/**
 * 
 * @export
 * @interface SiteDataResponse
 */
export interface SiteDataResponse {
    /**
     * 
     * @type {Array<SiteReadingResponse>}
     * @memberof SiteDataResponse
     */
    'readings': Array<SiteReadingResponse>;
}
/**
 * 
 * @export
 * @interface SiteFinancialCreditLineDataResponse
 */
export interface SiteFinancialCreditLineDataResponse {
    /**
     * 
     * @type {number}
     * @memberof SiteFinancialCreditLineDataResponse
     */
    'utctime': number;
    /**
     * 
     * @type {number}
     * @memberof SiteFinancialCreditLineDataResponse
     */
    'credit': number;
}
/**
 * 
 * @export
 * @interface SiteFinancialTotalMonthlySavingsResponse
 */
export interface SiteFinancialTotalMonthlySavingsResponse {
    /**
     * 
     * @type {number}
     * @memberof SiteFinancialTotalMonthlySavingsResponse
     */
    'period': number;
    /**
     * 
     * @type {number}
     * @memberof SiteFinancialTotalMonthlySavingsResponse
     */
    'elion': number;
    /**
     * 
     * @type {number}
     * @memberof SiteFinancialTotalMonthlySavingsResponse
     */
    'battery': number;
    /**
     * 
     * @type {number}
     * @memberof SiteFinancialTotalMonthlySavingsResponse
     */
    'solar': number;
}
/**
 * 
 * @export
 * @interface SiteFinancialTotalSavingsDataResponse
 */
export interface SiteFinancialTotalSavingsDataResponse {
    /**
     * 
     * @type {string}
     * @memberof SiteFinancialTotalSavingsDataResponse
     */
    'invoiceMode': string;
    /**
     * 
     * @type {number}
     * @memberof SiteFinancialTotalSavingsDataResponse
     */
    'profit': number;
}
/**
 * 
 * @export
 * @interface SiteFinancialBeforeAfterResponse
 */
export interface SiteFinancialBeforeAfterResponse {
    /**
     * 
     * @type {number}
     * @memberof SiteFinancialBeforeAfterResponse
     */
    'period': number;
    /**
     * 
     * @type {number}
     * @memberof SiteFinancialBeforeAfterResponse
     */
    'before_client_total': number;
    /**
     * 
     * @type {number}
     * @memberof SiteFinancialBeforeAfterResponse
     */
    'after_total': number;
}
/**
 * 
 * @export
 * @interface SiteForecastDataResponse
 */
export interface SiteForecastDataResponse {
    /**
     * 
     * @type {number}
     * @memberof SiteForecastDataResponse
     */
    'utctime': number;
    /**
     * 
     * @type {number}
     * @memberof SiteForecastDataResponse
     */
    'forecast'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteForecastDataResponse
     */
    'nominated'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteForecastDataResponse
     */
    'actual'?: number;
}
/**
 * 
 * @export
 * @interface SiteLiveDataResponse
 */
export interface SiteLiveDataResponse {
    /**
     * 
     * @type {number}
     * @memberof SiteLiveDataResponse
     */
    'grid'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteLiveDataResponse
     */
    'consumption'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteLiveDataResponse
     */
    'production'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteLiveDataResponse
     */
    'soc'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteLiveDataResponse
     */
    'flex'?: number;
}
/**
 * 
 * @export
 * @interface SiteMeteringCommodityPeaksDataResponse
 */
export interface SiteMeteringCommodityPeaksDataResponse {
    /**
     * 
     * @type {string}
     * @memberof SiteMeteringCommodityPeaksDataResponse
     */
    'invoiceMode': string;
    /**
     * 
     * @type {number}
     * @memberof SiteMeteringCommodityPeaksDataResponse
     */
    'capacityPeak': number;
    /**
     * 
     * @type {number}
     * @memberof SiteMeteringCommodityPeaksDataResponse
     */
    'excessPower': number;
}
/**
 * 
 * @export
 * @interface SiteMeteringCommodityVolumesDataResponse
 */
export interface SiteMeteringCommodityVolumesDataResponse {
    /**
     * 
     * @type {string}
     * @memberof SiteMeteringCommodityVolumesDataResponse
     */
    'invoiceMode': string;
    /**
     * 
     * @type {number}
     * @memberof SiteMeteringCommodityVolumesDataResponse
     */
    'gridOfftake': number;
    /**
     * 
     * @type {number}
     * @memberof SiteMeteringCommodityVolumesDataResponse
     */
    'gridInjection': number;
}
/**
 * 
 * @export
 * @interface SitePropertiesResponse
 */
export interface SitePropertiesResponse {
    /**
     * 
     * @type {number}
     * @memberof SitePropertiesResponse
     */
    'batteryCapacity'?: number;
    /**
     * 
     * @type {number}
     * @memberof SitePropertiesResponse
     */
    'inverterPower'?: number;
}
/**
 * 
 * @export
 * @interface SiteReadingResponse
 */
export interface SiteReadingResponse {
    /**
     * 
     * @type {string}
     * @memberof SiteReadingResponse
     */
    'action'?: string;
    /**
     * 
     * @type {number}
     * @memberof SiteReadingResponse
     */
    'flexCharge'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteReadingResponse
     */
    'flexDischarge'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteReadingResponse
     */
    'consumption'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteReadingResponse
     */
    'production'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteReadingResponse
     */
    'curtailedProduction'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteReadingResponse
     */
    'uncurtailedProduction'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteReadingResponse
     */
    'grid'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteReadingResponse
     */
    'gridOfftake'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteReadingResponse
     */
    'gridInject'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteReadingResponse
     */
    'soc'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteReadingResponse
     */
    'imbPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteReadingResponse
     */
    'sysImb'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteReadingResponse
     */
    'epex'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteReadingResponse
     */
    'costNoElion'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteReadingResponse
     */
    'costElion'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteReadingResponse
     */
    'profitElion'?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteReadingResponse
     */
    'utctime'?: number;
}
/**
 * 
 * @export
 * @interface SiteResponse
 */
export interface SiteResponse {
    /**
     * 
     * @type {string}
     * @memberof SiteResponse
     */
    'serialId': string;
    /**
     * 
     * @type {string}
     * @memberof SiteResponse
     */
    'siteId': string;
    /**
     * 
     * @type {string}
     * @memberof SiteResponse
     */
    'account': string;
    /**
     * 
     * @type {SiteAddressResponse}
     * @memberof SiteResponse
     */
    'address': SiteAddressResponse;
    /**
     * 
     * @type {SitePropertiesResponse}
     * @memberof SiteResponse
     */
    'properties': SitePropertiesResponse;
}
/**
 * 
 * @export
 * @interface TokenResponse
 */
export interface TokenResponse {
    /**
     * 
     * @type {string}
     * @memberof TokenResponse
     */
    'accessToken': string;
    /**
     * 
     * @type {string}
     * @memberof TokenResponse
     */
    'tokenType': string;
}
/**
 * 
 * @export
 * @interface UserResponse
 */
export interface UserResponse {
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'email'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponse
     */
    'advanced'?: boolean;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<LocationInner>}
     * @memberof ValidationError
     */
    'loc': Array<LocationInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}

/**
 * AnalyticsApi - axios parameter creator
 * @export
 */
export const AnalyticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Logs anonymous analytics usage behaviour
         * @summary Log Analytics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logAnalyticsApiAnalyticsPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/analytics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnalyticsApi - functional programming interface
 * @export
 */
export const AnalyticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnalyticsApiAxiosParamCreator(configuration)
    return {
        /**
         * Logs anonymous analytics usage behaviour
         * @summary Log Analytics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logAnalyticsApiAnalyticsPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logAnalyticsApiAnalyticsPost(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AnalyticsApi.logAnalyticsApiAnalyticsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * AnalyticsApi - factory interface
 * @export
 */
export const AnalyticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnalyticsApiFp(configuration)
    return {
        /**
         * Logs anonymous analytics usage behaviour
         * @summary Log Analytics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logAnalyticsApiAnalyticsPost(options?: any): AxiosPromise<void> {
            return localVarFp.logAnalyticsApiAnalyticsPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnalyticsApi - object-oriented interface
 * @export
 * @class AnalyticsApi
 * @extends {BaseAPI}
 */
export class AnalyticsApi extends BaseAPI {
    /**
     * Logs anonymous analytics usage behaviour
     * @summary Log Analytics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public logAnalyticsApiAnalyticsPost(options?: AxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).logAnalyticsApiAnalyticsPost(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthenticateApi - axios parameter creator
 * @export
 */
export const AuthenticateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get JWT Token for username and password
         * @summary Get Token
         * @param {string} username 
         * @param {string} password 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenApiLoginPost: async (username: string, password: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getTokenApiLoginPost', 'username', username)
            // verify required parameter 'password' is not null or undefined
            assertParamExists('getTokenApiLoginPost', 'password', password)
            const localVarPath = `/api/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (username !== undefined) { 
                localVarFormParams.set('username', username as any);
            }
    
            if (password !== undefined) { 
                localVarFormParams.set('password', password as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refresh token with provided refresh token in cookies
         * @summary Refresh Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokenApiTokenRefreshPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/token/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticateApi - functional programming interface
 * @export
 */
export const AuthenticateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticateApiAxiosParamCreator(configuration)
    return {
        /**
         * Get JWT Token for username and password
         * @summary Get Token
         * @param {string} username 
         * @param {string} password 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTokenApiLoginPost(username: string, password: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTokenApiLoginPost(username, password, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthenticateApi.getTokenApiLoginPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Refresh token with provided refresh token in cookies
         * @summary Refresh Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshTokenApiTokenRefreshPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshTokenApiTokenRefreshPost(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthenticateApi.refreshTokenApiTokenRefreshPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * AuthenticateApi - factory interface
 * @export
 */
export const AuthenticateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticateApiFp(configuration)
    return {
        /**
         * Get JWT Token for username and password
         * @summary Get Token
         * @param {string} username 
         * @param {string} password 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenApiLoginPost(username: string, password: string, options?: any): AxiosPromise<TokenResponse> {
            return localVarFp.getTokenApiLoginPost(username, password, options).then((request) => request(axios, basePath));
        },
        /**
         * Refresh token with provided refresh token in cookies
         * @summary Refresh Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokenApiTokenRefreshPost(options?: any): AxiosPromise<TokenResponse> {
            return localVarFp.refreshTokenApiTokenRefreshPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticateApi - object-oriented interface
 * @export
 * @class AuthenticateApi
 * @extends {BaseAPI}
 */
export class AuthenticateApi extends BaseAPI {
    /**
     * Get JWT Token for username and password
     * @summary Get Token
     * @param {string} username 
     * @param {string} password 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticateApi
     */
    public getTokenApiLoginPost(username: string, password: string, options?: AxiosRequestConfig) {
        return AuthenticateApiFp(this.configuration).getTokenApiLoginPost(username, password, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refresh token with provided refresh token in cookies
     * @summary Refresh Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticateApi
     */
    public refreshTokenApiTokenRefreshPost(options?: AxiosRequestConfig) {
        return AuthenticateApiFp(this.configuration).refreshTokenApiTokenRefreshPost(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SiteApi - axios parameter creator
 * @export
 */
export const SiteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Return a list will all sites available to the user logged in.
         * @summary Get
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSitesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sites/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return a list will all sites available to the user logged in.
         * @summary Get
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSitesIncomingGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sites/incoming`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves commodity peaks about the site for a specific period  :param site_id: Site ID of the site :param fromts: Day of month in epochseconds :return: Data commodity peaks for this site for the month in which the from day falls.
         * @summary Get Commodity Peaks
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommodityPeaksApiSitesSiteIdMeteringCommodityPeaksGet: async (siteId: string, fromts: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('getCommodityPeaksApiSitesSiteIdMeteringCommodityPeaksGet', 'siteId', siteId)
            // verify required parameter 'fromts' is not null or undefined
            assertParamExists('getCommodityPeaksApiSitesSiteIdMeteringCommodityPeaksGet', 'fromts', fromts)
            const localVarPath = `/api/sites/{site_id}/metering/commodity/peaks`
                .replace(`{${"site_id"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromts !== undefined) {
                localVarQueryParameter['fromts'] = fromts;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves commodity volumes about the site for a specific period  :param site_id: Site ID of the site :param fromts: Day of month in epochseconds :return: Data commodity volumes for this site for the month in which the from day falls.
         * @summary Get Commodity Volumes
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommodityVolumesApiSitesSiteIdMeteringCommodityVolumesGet: async (siteId: string, fromts: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('getCommodityVolumesApiSitesSiteIdMeteringCommodityVolumesGet', 'siteId', siteId)
            // verify required parameter 'fromts' is not null or undefined
            assertParamExists('getCommodityVolumesApiSitesSiteIdMeteringCommodityVolumesGet', 'fromts', fromts)
            const localVarPath = `/api/sites/{site_id}/metering/commodity/volumes`
                .replace(`{${"site_id"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromts !== undefined) {
                localVarQueryParameter['fromts'] = fromts;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves credit line data about the site for a specific period  :param site_id: Site ID of the site :param fromts: Start of period in epochseconds :param tots: End of period in epochseconds :return: Credit line data for this site in between the specified period
         * @summary Get Credit Line Data
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditLineDataApiSitesSiteIdFinancialCreditlineGet: async (siteId: string, fromts: number, tots: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('getCreditLineDataApiSitesSiteIdFinancialCreditlineGet', 'siteId', siteId)
            // verify required parameter 'fromts' is not null or undefined
            assertParamExists('getCreditLineDataApiSitesSiteIdFinancialCreditlineGet', 'fromts', fromts)
            // verify required parameter 'tots' is not null or undefined
            assertParamExists('getCreditLineDataApiSitesSiteIdFinancialCreditlineGet', 'tots', tots)
            const localVarPath = `/api/sites/{site_id}/financial/creditline`
                .replace(`{${"site_id"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromts !== undefined) {
                localVarQueryParameter['fromts'] = fromts;
            }

            if (tots !== undefined) {
                localVarQueryParameter['tots'] = tots;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves before and after invoice data for the site  :param site_id: Site ID of the site :param fromts: From timestamp :param tots: To timestamp :return: Before and after invoice data for this site in between the specified period
         * @summary Get Before After Invoices
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBeforeAfterInvoicesApiSitesSiteIdFinancialBeforeAfterGet: async (siteId: string, fromts: number, tots: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('getBeforeAfterInvoicesApiSitesSiteIdFinancialBeforeAfterGet', 'siteId', siteId)
            // verify required parameter 'fromts' is not null or undefined
            assertParamExists('getBeforeAfterInvoicesApiSitesSiteIdFinancialBeforeAfterGet', 'fromts', fromts)
            // verify required parameter 'tots' is not null or undefined
            assertParamExists('getBeforeAfterInvoicesApiSitesSiteIdFinancialBeforeAfterGet', 'tots', tots)
            const localVarPath = `/api/sites/{site_id}/financial/before-after`
                .replace(`{${"site_id"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromts !== undefined) {
                localVarQueryParameter['fromts'] = fromts;
            }

            if (tots !== undefined) {
                localVarQueryParameter['tots'] = tots;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves data readings about the site for a specific period  :param site_id: Site ID of the site :param fromts: Start of period in epochseconds :param tots: End of period in epochseconds :return: Data readings for this site in between the specified period
         * @summary Get Data
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataApiSitesSiteIdMeteringGet: async (siteId: string, fromts: number, tots: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('getDataApiSitesSiteIdMeteringGet', 'siteId', siteId)
            // verify required parameter 'fromts' is not null or undefined
            assertParamExists('getDataApiSitesSiteIdMeteringGet', 'fromts', fromts)
            // verify required parameter 'tots' is not null or undefined
            assertParamExists('getDataApiSitesSiteIdMeteringGet', 'tots', tots)
            const localVarPath = `/api/sites/{site_id}/metering`
                .replace(`{${"site_id"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromts !== undefined) {
                localVarQueryParameter['fromts'] = fromts;
            }

            if (tots !== undefined) {
                localVarQueryParameter['tots'] = tots;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves data export about the site for a specific period  :param site_id: Site ID of the site :param columns: All column names included in the excel export :param fromts: Start of period in epochseconds :param tots: End of period in epochseconds :return: Data readings for this site in between the specified period
         * @summary Get Data Export
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {Array<GetDataExportApiSitesSiteIdMeteringExportGetColumnsEnum>} columns Columns to export
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataExportApiSitesSiteIdMeteringExportGet: async (siteId: string, columns: Array<GetDataExportApiSitesSiteIdMeteringExportGetColumnsEnum>, fromts: number, tots: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('getDataExportApiSitesSiteIdMeteringExportGet', 'siteId', siteId)
            // verify required parameter 'columns' is not null or undefined
            assertParamExists('getDataExportApiSitesSiteIdMeteringExportGet', 'columns', columns)
            // verify required parameter 'fromts' is not null or undefined
            assertParamExists('getDataExportApiSitesSiteIdMeteringExportGet', 'fromts', fromts)
            // verify required parameter 'tots' is not null or undefined
            assertParamExists('getDataExportApiSitesSiteIdMeteringExportGet', 'tots', tots)
            const localVarPath = `/api/sites/{site_id}/metering/export`
                .replace(`{${"site_id"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (columns) {
                localVarQueryParameter['columns'] = columns;
            }

            if (fromts !== undefined) {
                localVarQueryParameter['fromts'] = fromts;
            }

            if (tots !== undefined) {
                localVarQueryParameter['tots'] = tots;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves forecast/actual data about the site  :param site_id: Site ID of the site :return: Forecast/Actual data for the site
         * @summary Get Forecast Data
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastDataApiSitesSiteIdForecastGet: async (siteId: string, fromts: number, tots: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('getForecastDataApiSitesSiteIdForecastGet', 'siteId', siteId)
            // verify required parameter 'fromts' is not null or undefined
            assertParamExists('getForecastDataApiSitesSiteIdForecastGet', 'fromts', fromts)
            // verify required parameter 'tots' is not null or undefined
            assertParamExists('getForecastDataApiSitesSiteIdForecastGet', 'tots', tots)
            const localVarPath = `/api/sites/{site_id}/forecast`
                .replace(`{${"site_id"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromts !== undefined) {
                localVarQueryParameter['fromts'] = fromts;
            }

            if (tots !== undefined) {
                localVarQueryParameter['tots'] = tots;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves live data about the site  :param site_id: Site ID of the site :return: Live data for the site
         * @summary Get Live Data
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiveDataApiSitesSiteIdLiveGet: async (siteId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('getLiveDataApiSitesSiteIdLiveGet', 'siteId', siteId)
            const localVarPath = `/api/sites/{site_id}/live`
                .replace(`{${"site_id"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves profit vs nobatt data about the site  :param site_id: Site ID of the site :return: Credit line data for this site in between the specified period
         * @summary Get Monthly Savings
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlySavingsApiSitesSiteIdFinancialMonthlySavingsGet: async (siteId: string, fromts: number, tots: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('getMonthlySavingsApiSitesSiteIdFinancialMonthlySavingsGet', 'siteId', siteId)
            // verify required parameter 'fromts' is not null or undefined
            assertParamExists('getMonthlySavingsApiSitesSiteIdFinancialMonthlySavingsGet', 'fromts', fromts)
            // verify required parameter 'tots' is not null or undefined
            assertParamExists('getMonthlySavingsApiSitesSiteIdFinancialMonthlySavingsGet', 'tots', tots)
            const localVarPath = `/api/sites/{site_id}/financial/monthly-savings`
                .replace(`{${"site_id"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromts !== undefined) {
                localVarQueryParameter['fromts'] = fromts;
            }

            if (tots !== undefined) {
                localVarQueryParameter['tots'] = tots;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves total savings data about the site for a specific period  :param site_id: Site ID of the site :param fromts: Start of period in epochseconds :param tots: End of period in epochseconds :return: Savings calculation for this site in between the specified period
         * @summary Get Savings Between
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsBetweenApiSitesSiteIdFinancialSavingsGet: async (siteId: string, fromts: number, tots: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('getSavingsBetweenApiSitesSiteIdFinancialSavingsGet', 'siteId', siteId)
            // verify required parameter 'fromts' is not null or undefined
            assertParamExists('getSavingsBetweenApiSitesSiteIdFinancialSavingsGet', 'fromts', fromts)
            // verify required parameter 'tots' is not null or undefined
            assertParamExists('getSavingsBetweenApiSitesSiteIdFinancialSavingsGet', 'tots', tots)
            const localVarPath = `/api/sites/{site_id}/financial/savings`
                .replace(`{${"site_id"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromts !== undefined) {
                localVarQueryParameter['fromts'] = fromts;
            }

            if (tots !== undefined) {
                localVarQueryParameter['tots'] = tots;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns if the selected site has any errors in the provided period causing possible weird data  :param site_id: Site ID of the site :return: Boolean about the error status for the site in between the specified period
         * @summary Has Errors Between
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasErrorsBetweenApiSitesSiteIdHasErrorsGet: async (siteId: string, fromts: number, tots: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('hasErrorsBetweenApiSitesSiteIdHasErrorsGet', 'siteId', siteId)
            // verify required parameter 'fromts' is not null or undefined
            assertParamExists('hasErrorsBetweenApiSitesSiteIdHasErrorsGet', 'fromts', fromts)
            // verify required parameter 'tots' is not null or undefined
            assertParamExists('hasErrorsBetweenApiSitesSiteIdHasErrorsGet', 'tots', tots)
            const localVarPath = `/api/sites/{site_id}/has-errors`
                .replace(`{${"site_id"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromts !== undefined) {
                localVarQueryParameter['fromts'] = fromts;
            }

            if (tots !== undefined) {
                localVarQueryParameter['tots'] = tots;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SiteApi - functional programming interface
 * @export
 */
export const SiteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SiteApiAxiosParamCreator(configuration)
    return {
        /**
         * Return a list will all sites available to the user logged in.
         * @summary Get
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiSitesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SiteResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiSitesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SiteApi.getApiSitesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Return a list will all sites available to the user logged in.
         * @summary Get
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiSitesIncomingGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SiteResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiSitesIncomingGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SiteApi.getApiSitesIncomingGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Retrieves commodity peaks about the site for a specific period  :param site_id: Site ID of the site :param fromts: Day of month in epochseconds :return: Data commodity peaks for this site for the month in which the from day falls.
         * @summary Get Commodity Peaks
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommodityPeaksApiSitesSiteIdMeteringCommodityPeaksGet(siteId: string, fromts: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SiteMeteringCommodityPeaksDataResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommodityPeaksApiSitesSiteIdMeteringCommodityPeaksGet(siteId, fromts, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SiteApi.getCommodityPeaksApiSitesSiteIdMeteringCommodityPeaksGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Retrieves commodity volumes about the site for a specific period  :param site_id: Site ID of the site :param fromts: Day of month in epochseconds :return: Data commodity volumes for this site for the month in which the from day falls.
         * @summary Get Commodity Volumes
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommodityVolumesApiSitesSiteIdMeteringCommodityVolumesGet(siteId: string, fromts: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SiteMeteringCommodityVolumesDataResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommodityVolumesApiSitesSiteIdMeteringCommodityVolumesGet(siteId, fromts, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SiteApi.getCommodityVolumesApiSitesSiteIdMeteringCommodityVolumesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Retrieves credit line data about the site for a specific period  :param site_id: Site ID of the site :param fromts: Start of period in epochseconds :param tots: End of period in epochseconds :return: Credit line data for this site in between the specified period
         * @summary Get Credit Line Data
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCreditLineDataApiSitesSiteIdFinancialCreditlineGet(siteId: string, fromts: number, tots: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SiteFinancialCreditLineDataResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCreditLineDataApiSitesSiteIdFinancialCreditlineGet(siteId, fromts, tots, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SiteApi.getCreditLineDataApiSitesSiteIdFinancialCreditlineGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Retrieves before and after invoice data for the site  :param site_id: Site ID of the site :param fromts: From timestamp :param tots: To timestamp :return: Before and after invoice data for this site in between the specified period
         * @summary Get Before After Invoices
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBeforeAfterInvoicesApiSitesSiteIdFinancialBeforeAfterGet(siteId: string, fromts: number, tots: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SiteFinancialBeforeAfterResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBeforeAfterInvoicesApiSitesSiteIdFinancialBeforeAfterGet(siteId, fromts, tots, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SiteApi.getBeforeAfterInvoicesApiSitesSiteIdFinancialBeforeAfterGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Retrieves data readings about the site for a specific period  :param site_id: Site ID of the site :param fromts: Start of period in epochseconds :param tots: End of period in epochseconds :return: Data readings for this site in between the specified period
         * @summary Get Data
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataApiSitesSiteIdMeteringGet(siteId: string, fromts: number, tots: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SiteDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataApiSitesSiteIdMeteringGet(siteId, fromts, tots, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SiteApi.getDataApiSitesSiteIdMeteringGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Retrieves data export about the site for a specific period  :param site_id: Site ID of the site :param columns: All column names included in the excel export :param fromts: Start of period in epochseconds :param tots: End of period in epochseconds :return: Data readings for this site in between the specified period
         * @summary Get Data Export
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {Array<GetDataExportApiSitesSiteIdMeteringExportGetColumnsEnum>} columns Columns to export
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataExportApiSitesSiteIdMeteringExportGet(siteId: string, columns: Array<GetDataExportApiSitesSiteIdMeteringExportGetColumnsEnum>, fromts: number, tots: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataExportApiSitesSiteIdMeteringExportGet(siteId, columns, fromts, tots, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SiteApi.getDataExportApiSitesSiteIdMeteringExportGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Retrieves forecast/actual data about the site  :param site_id: Site ID of the site :return: Forecast/Actual data for the site
         * @summary Get Forecast Data
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForecastDataApiSitesSiteIdForecastGet(siteId: string, fromts: number, tots: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SiteForecastDataResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForecastDataApiSitesSiteIdForecastGet(siteId, fromts, tots, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SiteApi.getForecastDataApiSitesSiteIdForecastGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Retrieves live data about the site  :param site_id: Site ID of the site :return: Live data for the site
         * @summary Get Live Data
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLiveDataApiSitesSiteIdLiveGet(siteId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SiteLiveDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLiveDataApiSitesSiteIdLiveGet(siteId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SiteApi.getLiveDataApiSitesSiteIdLiveGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Retrieves profit vs nobatt data about the site  :param site_id: Site ID of the site :return: Credit line data for this site in between the specified period
         * @summary Get Monthly Savings
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMonthlySavingsApiSitesSiteIdFinancialMonthlySavingsGet(siteId: string, fromts: number, tots: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SiteFinancialTotalMonthlySavingsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMonthlySavingsApiSitesSiteIdFinancialMonthlySavingsGet(siteId, fromts, tots, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SiteApi.getMonthlySavingsApiSitesSiteIdFinancialMonthlySavingsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Retrieves total savings data about the site for a specific period  :param site_id: Site ID of the site :param fromts: Start of period in epochseconds :param tots: End of period in epochseconds :return: Savings calculation for this site in between the specified period
         * @summary Get Savings Between
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSavingsBetweenApiSitesSiteIdFinancialSavingsGet(siteId: string, fromts: number, tots: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SiteFinancialTotalSavingsDataResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSavingsBetweenApiSitesSiteIdFinancialSavingsGet(siteId, fromts, tots, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SiteApi.getSavingsBetweenApiSitesSiteIdFinancialSavingsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Returns if the selected site has any errors in the provided period causing possible weird data  :param site_id: Site ID of the site :return: Boolean about the error status for the site in between the specified period
         * @summary Has Errors Between
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hasErrorsBetweenApiSitesSiteIdHasErrorsGet(siteId: string, fromts: number, tots: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hasErrorsBetweenApiSitesSiteIdHasErrorsGet(siteId, fromts, tots, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SiteApi.hasErrorsBetweenApiSitesSiteIdHasErrorsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * SiteApi - factory interface
 * @export
 */
export const SiteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SiteApiFp(configuration)
    return {
        /**
         * Return a list will all sites available to the user logged in.
         * @summary Get
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSitesGet(options?: any): AxiosPromise<Array<SiteResponse>> {
            return localVarFp.getApiSitesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Return a list will all sites available to the user logged in.
         * @summary Get
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSitesIncomingGet(options?: any): AxiosPromise<Array<SiteResponse>> {
            return localVarFp.getApiSitesIncomingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves commodity peaks about the site for a specific period  :param site_id: Site ID of the site :param fromts: Day of month in epochseconds :return: Data commodity peaks for this site for the month in which the from day falls.
         * @summary Get Commodity Peaks
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommodityPeaksApiSitesSiteIdMeteringCommodityPeaksGet(siteId: string, fromts: number, options?: any): AxiosPromise<Array<SiteMeteringCommodityPeaksDataResponse>> {
            return localVarFp.getCommodityPeaksApiSitesSiteIdMeteringCommodityPeaksGet(siteId, fromts, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves commodity volumes about the site for a specific period  :param site_id: Site ID of the site :param fromts: Day of month in epochseconds :return: Data commodity volumes for this site for the month in which the from day falls.
         * @summary Get Commodity Volumes
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommodityVolumesApiSitesSiteIdMeteringCommodityVolumesGet(siteId: string, fromts: number, options?: any): AxiosPromise<Array<SiteMeteringCommodityVolumesDataResponse>> {
            return localVarFp.getCommodityVolumesApiSitesSiteIdMeteringCommodityVolumesGet(siteId, fromts, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves credit line data about the site for a specific period  :param site_id: Site ID of the site :param fromts: Start of period in epochseconds :param tots: End of period in epochseconds :return: Credit line data for this site in between the specified period
         * @summary Get Credit Line Data
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditLineDataApiSitesSiteIdFinancialCreditlineGet(siteId: string, fromts: number, tots: number, options?: any): AxiosPromise<Array<SiteFinancialCreditLineDataResponse>> {
            return localVarFp.getCreditLineDataApiSitesSiteIdFinancialCreditlineGet(siteId, fromts, tots, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves before and after invoice data for the site  :param site_id: Site ID of the site :param fromts: From timestamp :param tots: To timestamp :return: Before and after invoice data for this site in between the specified period
         * @summary Get Before After Invoices
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBeforeAfterInvoicesApiSitesSiteIdFinancialBeforeAfterGet(siteId: string, fromts: number, tots: number, options?: any): AxiosPromise<Array<SiteFinancialBeforeAfterResponse>> {
            return localVarFp.getBeforeAfterInvoicesApiSitesSiteIdFinancialBeforeAfterGet(siteId, fromts, tots, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves data readings about the site for a specific period  :param site_id: Site ID of the site :param fromts: Start of period in epochseconds :param tots: End of period in epochseconds :return: Data readings for this site in between the specified period
         * @summary Get Data
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataApiSitesSiteIdMeteringGet(siteId: string, fromts: number, tots: number, options?: any): AxiosPromise<SiteDataResponse> {
            return localVarFp.getDataApiSitesSiteIdMeteringGet(siteId, fromts, tots, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves data export about the site for a specific period  :param site_id: Site ID of the site :param columns: All column names included in the excel export :param fromts: Start of period in epochseconds :param tots: End of period in epochseconds :return: Data readings for this site in between the specified period
         * @summary Get Data Export
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {Array<GetDataExportApiSitesSiteIdMeteringExportGetColumnsEnum>} columns Columns to export
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataExportApiSitesSiteIdMeteringExportGet(siteId: string, columns: Array<GetDataExportApiSitesSiteIdMeteringExportGetColumnsEnum>, fromts: number, tots: number, options?: any): AxiosPromise<any> {
            return localVarFp.getDataExportApiSitesSiteIdMeteringExportGet(siteId, columns, fromts, tots, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves forecast/actual data about the site  :param site_id: Site ID of the site :return: Forecast/Actual data for the site
         * @summary Get Forecast Data
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastDataApiSitesSiteIdForecastGet(siteId: string, fromts: number, tots: number, options?: any): AxiosPromise<Array<SiteForecastDataResponse>> {
            return localVarFp.getForecastDataApiSitesSiteIdForecastGet(siteId, fromts, tots, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves live data about the site  :param site_id: Site ID of the site :return: Live data for the site
         * @summary Get Live Data
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiveDataApiSitesSiteIdLiveGet(siteId: string, options?: any): AxiosPromise<SiteLiveDataResponse> {
            return localVarFp.getLiveDataApiSitesSiteIdLiveGet(siteId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves profit vs nobatt data about the site  :param site_id: Site ID of the site :return: Credit line data for this site in between the specified period
         * @summary Get Monthly Savings
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlySavingsApiSitesSiteIdFinancialMonthlySavingsGet(siteId: string, fromts: number, tots: number, options?: any): AxiosPromise<Array<SiteFinancialTotalMonthlySavingsResponse>> {
            return localVarFp.getMonthlySavingsApiSitesSiteIdFinancialMonthlySavingsGet(siteId, fromts, tots, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves total savings data about the site for a specific period  :param site_id: Site ID of the site :param fromts: Start of period in epochseconds :param tots: End of period in epochseconds :return: Savings calculation for this site in between the specified period
         * @summary Get Savings Between
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsBetweenApiSitesSiteIdFinancialSavingsGet(siteId: string, fromts: number, tots: number, options?: any): AxiosPromise<Array<SiteFinancialTotalSavingsDataResponse>> {
            return localVarFp.getSavingsBetweenApiSitesSiteIdFinancialSavingsGet(siteId, fromts, tots, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns if the selected site has any errors in the provided period causing possible weird data  :param site_id: Site ID of the site :return: Boolean about the error status for the site in between the specified period
         * @summary Has Errors Between
         * @param {string} siteId The site id of the site you want to retrieve data for.
         * @param {number} fromts From timestamp
         * @param {number} tots To timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasErrorsBetweenApiSitesSiteIdHasErrorsGet(siteId: string, fromts: number, tots: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.hasErrorsBetweenApiSitesSiteIdHasErrorsGet(siteId, fromts, tots, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SiteApi - object-oriented interface
 * @export
 * @class SiteApi
 * @extends {BaseAPI}
 */
export class SiteApi extends BaseAPI {
    /**
     * Return a list will all sites available to the user logged in.
     * @summary Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    public getApiSitesGet(options?: AxiosRequestConfig) {
        return SiteApiFp(this.configuration).getApiSitesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return a list will all sites available to the user logged in.
     * @summary Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    public getApiSitesIncomingGet(options?: AxiosRequestConfig) {
        return SiteApiFp(this.configuration).getApiSitesIncomingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves commodity peaks about the site for a specific period  :param site_id: Site ID of the site :param fromts: Day of month in epochseconds :return: Data commodity peaks for this site for the month in which the from day falls.
     * @summary Get Commodity Peaks
     * @param {string} siteId The site id of the site you want to retrieve data for.
     * @param {number} fromts From timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    public getCommodityPeaksApiSitesSiteIdMeteringCommodityPeaksGet(siteId: string, fromts: number, options?: AxiosRequestConfig) {
        return SiteApiFp(this.configuration).getCommodityPeaksApiSitesSiteIdMeteringCommodityPeaksGet(siteId, fromts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves commodity volumes about the site for a specific period  :param site_id: Site ID of the site :param fromts: Day of month in epochseconds :return: Data commodity volumes for this site for the month in which the from day falls.
     * @summary Get Commodity Volumes
     * @param {string} siteId The site id of the site you want to retrieve data for.
     * @param {number} fromts From timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    public getCommodityVolumesApiSitesSiteIdMeteringCommodityVolumesGet(siteId: string, fromts: number, options?: AxiosRequestConfig) {
        return SiteApiFp(this.configuration).getCommodityVolumesApiSitesSiteIdMeteringCommodityVolumesGet(siteId, fromts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves credit line data about the site for a specific period  :param site_id: Site ID of the site :param fromts: Start of period in epochseconds :param tots: End of period in epochseconds :return: Credit line data for this site in between the specified period
     * @summary Get Credit Line Data
     * @param {string} siteId The site id of the site you want to retrieve data for.
     * @param {number} fromts From timestamp
     * @param {number} tots To timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    public getCreditLineDataApiSitesSiteIdFinancialCreditlineGet(siteId: string, fromts: number, tots: number, options?: AxiosRequestConfig) {
        return SiteApiFp(this.configuration).getCreditLineDataApiSitesSiteIdFinancialCreditlineGet(siteId, fromts, tots, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves before and after invoice data for the site  :param site_id: Site ID of the site :param fromts: From timestamp :param tots: To timestamp :return: Before and after invoice data for this site in between the specified period
     * @summary Get Before After Invoices
     * @param {string} siteId The site id of the site you want to retrieve data for.
     * @param {number} fromts From timestamp
     * @param {number} tots To timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    public getBeforeAfterInvoicesApiSitesSiteIdFinancialBeforeAfterGet(siteId: string, fromts: number, tots: number, options?: AxiosRequestConfig) {
        return SiteApiFp(this.configuration).getBeforeAfterInvoicesApiSitesSiteIdFinancialBeforeAfterGet(siteId, fromts, tots, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves data readings about the site for a specific period  :param site_id: Site ID of the site :param fromts: Start of period in epochseconds :param tots: End of period in epochseconds :return: Data readings for this site in between the specified period
     * @summary Get Data
     * @param {string} siteId The site id of the site you want to retrieve data for.
     * @param {number} fromts From timestamp
     * @param {number} tots To timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    public getDataApiSitesSiteIdMeteringGet(siteId: string, fromts: number, tots: number, options?: AxiosRequestConfig) {
        return SiteApiFp(this.configuration).getDataApiSitesSiteIdMeteringGet(siteId, fromts, tots, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves data export about the site for a specific period  :param site_id: Site ID of the site :param columns: All column names included in the excel export :param fromts: Start of period in epochseconds :param tots: End of period in epochseconds :return: Data readings for this site in between the specified period
     * @summary Get Data Export
     * @param {string} siteId The site id of the site you want to retrieve data for.
     * @param {Array<GetDataExportApiSitesSiteIdMeteringExportGetColumnsEnum>} columns Columns to export
     * @param {number} fromts From timestamp
     * @param {number} tots To timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    public getDataExportApiSitesSiteIdMeteringExportGet(siteId: string, columns: Array<GetDataExportApiSitesSiteIdMeteringExportGetColumnsEnum>, fromts: number, tots: number, options?: AxiosRequestConfig) {
        return SiteApiFp(this.configuration).getDataExportApiSitesSiteIdMeteringExportGet(siteId, columns, fromts, tots, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves forecast/actual data about the site  :param site_id: Site ID of the site :return: Forecast/Actual data for the site
     * @summary Get Forecast Data
     * @param {string} siteId The site id of the site you want to retrieve data for.
     * @param {number} fromts From timestamp
     * @param {number} tots To timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    public getForecastDataApiSitesSiteIdForecastGet(siteId: string, fromts: number, tots: number, options?: AxiosRequestConfig) {
        return SiteApiFp(this.configuration).getForecastDataApiSitesSiteIdForecastGet(siteId, fromts, tots, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves live data about the site  :param site_id: Site ID of the site :return: Live data for the site
     * @summary Get Live Data
     * @param {string} siteId The site id of the site you want to retrieve data for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    public getLiveDataApiSitesSiteIdLiveGet(siteId: string, options?: AxiosRequestConfig) {
        return SiteApiFp(this.configuration).getLiveDataApiSitesSiteIdLiveGet(siteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves profit vs nobatt data about the site  :param site_id: Site ID of the site :return: Credit line data for this site in between the specified period
     * @summary Get Monthly Savings
     * @param {string} siteId The site id of the site you want to retrieve data for.
     * @param {number} fromts From timestamp
     * @param {number} tots To timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    public getMonthlySavingsApiSitesSiteIdFinancialMonthlySavingsGet(siteId: string, fromts: number, tots: number, options?: AxiosRequestConfig) {
        return SiteApiFp(this.configuration).getMonthlySavingsApiSitesSiteIdFinancialMonthlySavingsGet(siteId, fromts, tots, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves total savings data about the site for a specific period  :param site_id: Site ID of the site :param fromts: Start of period in epochseconds :param tots: End of period in epochseconds :return: Savings calculation for this site in between the specified period
     * @summary Get Savings Between
     * @param {string} siteId The site id of the site you want to retrieve data for.
     * @param {number} fromts From timestamp
     * @param {number} tots To timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    public getSavingsBetweenApiSitesSiteIdFinancialSavingsGet(siteId: string, fromts: number, tots: number, options?: AxiosRequestConfig) {
        return SiteApiFp(this.configuration).getSavingsBetweenApiSitesSiteIdFinancialSavingsGet(siteId, fromts, tots, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns if the selected site has any errors in the provided period causing possible weird data  :param site_id: Site ID of the site :return: Boolean about the error status for the site in between the specified period
     * @summary Has Errors Between
     * @param {string} siteId The site id of the site you want to retrieve data for.
     * @param {number} fromts From timestamp
     * @param {number} tots To timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    public hasErrorsBetweenApiSitesSiteIdHasErrorsGet(siteId: string, fromts: number, tots: number, options?: AxiosRequestConfig) {
        return SiteApiFp(this.configuration).hasErrorsBetweenApiSitesSiteIdHasErrorsGet(siteId, fromts, tots, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetDataExportApiSitesSiteIdMeteringExportGetColumnsEnum = {
    Utctime: 'utctime',
    Consumption: 'consumption',
    Production: 'production',
    FlexCharge: 'flex_charge',
    FlexDischarge: 'flex_discharge',
    CurtailedProduction: 'curtailed_production',
    UncurtailedProduction: 'uncurtailed_production',
    Grid: 'grid',
    GridOfftake: 'grid_offtake',
    GridInject: 'grid_inject',
    Soc: 'soc',
    ImbPrice: 'imb_price',
    Epex: 'epex',
    Forecast: 'forecast',
    Actual: 'actual',
    Nominated: 'nominated',
    CreditIncrement: 'credit_increment'
} as const;
export type GetDataExportApiSitesSiteIdMeteringExportGetColumnsEnum = typeof GetDataExportApiSitesSiteIdMeteringExportGetColumnsEnum[keyof typeof GetDataExportApiSitesSiteIdMeteringExportGetColumnsEnum];


/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns information about the user logged in.
         * @summary Get
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiUsersMeGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns information about the user logged in.
         * @summary Get
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiUsersMeGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiUsersMeGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UserApi.getApiUsersMeGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * Returns information about the user logged in.
         * @summary Get
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiUsersMeGet(options?: any): AxiosPromise<UserResponse> {
            return localVarFp.getApiUsersMeGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * Returns information about the user logged in.
     * @summary Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getApiUsersMeGet(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getApiUsersMeGet(options).then((request) => request(this.axios, this.basePath));
    }
}



